import { changeToken } from '../../../../Api';
import { notices_list, next_page_notices } from '../stores';
import { api } from '../../../../helpers';

export const listsNotices = async (page = 1) => {
  const response = await api(`/api/v2/notice/list/?page=${page}`);

  if (!response.ok) {
    changeToken(response.status);
    return; 
  }

  const data = await response.json();

  data.results = data.results.map((notice) => ({ ...notice, is_hidden: false }));

  notices_list.update((n) => [...n, ...data.results]);
  next_page_notices.update((n) => data.next);
};